import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Typography } from "@mui/material";
import html2pdf from "html2pdf.js";
import { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDispatch, useSelector } from "react-redux";
import SignatureCanvas from "react-signature-canvas";
import Custom3dotString from "../../../../components/Custom3dotString";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import CustomSelect from "../../../../components/Select/Select";
import {
  assignFormByAppointmentIdWoLoader,
  deletePetFromByIdWoLoader,
  getClinicFormsWoLoader,
  updateFromById,
  updatePetFromByIdWoLoader,
} from "../../../../redux/reducers/clinicSlice";
import { getPetsCompliantSummaryWoLoader } from "../../../../redux/reducers/petSlice";
import { AppColors } from "../../../../util/AppColors";
import {
  clearPdfBlobCache,
  loadPdfBlobUrl,
  normalizeFileUrl,
} from "../../../../util/pdfPreview";
import { canWriteModule } from "../../../../util/roleModuleAccess";

const delBtn = { color: AppColors.red, width: 20, height: 20 };
const eyeBtn = { color: AppColors.appPrimary, width: 20, height: 20 };
const addIcon = { color: AppColors.appPrimary, width: 15, height: 15 };

const PetForms = () => {
  const dispatch = useDispatch();
  const canManageDashboard = canWriteModule("dashboard");
  const pdfRef = useRef(null);
  const sigCanvas = useRef(null);
  const clinicFormFetchedRef = useRef(false);
  const [profileImg, setProfileImg] = useState();
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [vetSignUrl, setVetSignUrl] = useState(null);
  const [addModVsble, setAddModVsble] = useState(false);
  const [formValue, setFormValue] = useState(null);
  const [formErr, setFormErr] = useState(false);
  const [slctedItem, setSlctedItem] = useState(null);
  const [delModVsble, setDelModVsble] = useState(false);
  const [prevModVsble, setPrevModVsble] = useState(false);
  const [contPrevModVsble, setContPrevModVsble] = useState(false);
  const [signModVsble, setSignModVsble] = useState(false);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState("");
  const [pdfPreviewLoading, setPdfPreviewLoading] = useState(false);
  const [pdfPreviewError, setPdfPreviewError] = useState("");
  const [contentEditModVsble, setContentEditModVsble] = useState(false);
  const [editContent, setEditContent] = useState("");
  const pdfPreviewRequestRef = useRef(0);
  const { forms, details: clinicDet } = useSelector((state) => state?.clinic);
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const user = localStorage.getItem("user");
  const profile = JSON.parse(user);

  useEffect(() => {
    if (clinicFormFetchedRef.current) return;
    clinicFormFetchedRef.current = true;
    dispatch(getClinicFormsWoLoader());
  }, [dispatch]);

  useEffect(() => {
    if (clinicDet?.image) {
      fetch(clinicDet.image)
        .then((res) => res.blob())
        .then((blob) => {
          const reader = new FileReader();
          reader.readAsDataURL(blob);
          reader.onloadend = () => setProfileImg(reader.result);
        });
    }

    const fetchImage = async () => {
      if (!reqDet?.appointment?.signature) return;
      const res = await fetch(reqDet?.appointment?.signature, {
        method: "GET",
        headers: {},
      });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      setVetSignUrl(url);
    };

    fetchImage();
  }, [clinicDet?.image, reqDet?.appointment?.signature]);

  const callApi = () => {
    dispatch(
      getPetsCompliantSummaryWoLoader(reqDet?.appointment?.appointmentId),
    );
  };

  const getFormList = () => {
    return (
      forms
        // ?.filter((frm) => frm?.documentType === "Form")
        ?.map((cf) => ({ ...cf, value: cf?.formId }))
    );
  };

  const onCloseAddMod = () => {
    setAddModVsble(false);
  };

  const handleSave = (formId) => {
    if (!formId) return setFormErr(true);
    dispatch(
      assignFormByAppointmentIdWoLoader({
        apntId: reqDet?.appointment?.appointmentId,
        formId,
      }),
    ).then((res) => {
      if (res?.payload) {
        callApi();
        setAddModVsble(false);
        setFormValue(null);
        setFormErr(false);
      }
    });
  };

  const onChange = (value) => {
    setFormValue(value);
    setFormErr(!value?.formId);
  };

  const delForm = (dta) => {
    setSlctedItem(dta);
    setDelModVsble(true);
  };

  const onCloseDelMod = () => {
    setDelModVsble(false);
    setSlctedItem(null);
  };

  const onCofirmDelete = () => {
    if (!slctedItem?.petFormId) return;
    dispatch(deletePetFromByIdWoLoader(slctedItem?.petFormId))?.then((res) => {
      if (res?.payload) {
        onCloseDelMod();
        callApi();
      }
    });
  };

  const onCloseSignMod = () => {
    setSlctedItem(null);
    setSignModVsble(false);
    setContPrevModVsble(false);
    setSignatureUrl(null);
  };

  const handleSignature = () => {
    const newSignature = sigCanvas.current.toDataURL();
    setSignatureUrl(newSignature);
  };

  const onSaveSign = async () => {
    try {
      handleSignature();
      if (!pdfRef.current) return;
      html2pdf()
        .from(pdfRef.current)
        .outputPdf("blob")
        .then((blob) => {
          const form = new FormData();
          form.append("file", blob, `${Date.now()}sign.pdf`);
          dispatch(
            updatePetFromByIdWoLoader({ formId: slctedItem?.petFormId, form }),
          )?.then((res) => {
            if (res?.payload) {
              onCloseSignMod();
              callApi();
            }
          });
        });
    } catch (error) {}
  };

  const getMergedForm = (pf) => {
    const template = forms?.find((frm) => frm?.formId === pf?.formId) ?? {};
    return {
      ...template,
      ...pf,
      content: pf?.content ?? template?.content ?? "",
    };
  };

  const handleSign = (dta) => {
    setSlctedItem(getMergedForm(dta));
    setContPrevModVsble(true);
    // setSignModVsble(true);
  };

  async function downloadFile(url, fileName) {
    try {
      const normalizedUrl = normalizeFileUrl(url);
      if (!normalizedUrl) return;

      const blobUrl = await loadPdfBlobUrl(normalizedUrl);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Download failed", err);
    }
  }

  useEffect(() => {
    if (!prevModVsble || !slctedItem?.file) {
      setPdfPreviewUrl("");
      setPdfPreviewLoading(false);
      setPdfPreviewError("");
      return undefined;
    }

    const requestId = pdfPreviewRequestRef.current + 1;
    pdfPreviewRequestRef.current = requestId;
    const fileUrl = normalizeFileUrl(slctedItem.file);

    const loadPreview = async () => {
      setPdfPreviewLoading(true);
      setPdfPreviewError("");
      setPdfPreviewUrl("");

      try {
        const blobUrl = await loadPdfBlobUrl(fileUrl);
        if (pdfPreviewRequestRef.current !== requestId) return;
        setPdfPreviewUrl(blobUrl);
      } catch (error) {
        if (pdfPreviewRequestRef.current !== requestId) return;
        setPdfPreviewUrl(fileUrl);
        setPdfPreviewError(
          "Preview could not be loaded inline. Use Open in new tab.",
        );
      } finally {
        if (pdfPreviewRequestRef.current === requestId) {
          setPdfPreviewLoading(false);
        }
      }
    };

    loadPreview();

    return () => {
      if (pdfPreviewRequestRef.current === requestId) {
        pdfPreviewRequestRef.current += 1;
      }
    };
  }, [prevModVsble, slctedItem?.file, slctedItem?.petFormId]);

  useEffect(() => () => clearPdfBlobCache(), []);

  const handleView = (dta) => {
    const merged = getMergedForm(dta);
    setSlctedItem(merged);

    if (dta?.status && normalizeFileUrl(dta?.file)) {
      setPrevModVsble(true);
      return;
    }

    setEditContent(merged.content ?? "");
    setContentEditModVsble(true);
  };

  const onCloseContentEdit = () => {
    setContentEditModVsble(false);
    setEditContent("");
    setSlctedItem(null);
  };

  const onSaveContent = () => {
    if (!slctedItem?.formId) return;

    const data = {
      name: slctedItem?.name,
      serviceType: slctedItem?.serviceType,
      content: editContent,
      signed: "false",
    };

    dispatch(updateFromById({ formId: slctedItem.formId, data })).then(
      (res) => {
        if (res?.payload) {
          onCloseContentEdit();
          dispatch(getClinicFormsWoLoader());
          callApi();
        }
      },
    );
  };

  const onClosePreview = () => {
    pdfPreviewRequestRef.current += 1;
    setPrevModVsble(false);
    setSlctedItem(null);
    setPdfPreviewUrl("");
    setPdfPreviewLoading(false);
    setPdfPreviewError("");
  };

  const openPdfInNewTab = async () => {
    const fileUrl = normalizeFileUrl(slctedItem?.file);
    if (!fileUrl) return;

    try {
      const blobUrl = pdfPreviewUrl || (await loadPdfBlobUrl(fileUrl));
      window.open(blobUrl, "_blank", "noopener,noreferrer");
    } catch (error) {
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    }
  };

  const addEditShow = true;
  // reqDet?.appointment?.appointmentStatus?.toLowerCase() !== "completed" ||
  // (reqDet?.appointment?.appointmentStatus?.toLowerCase() === "completed" &&
  //   !reqDet?.appointment?.lock);

  return (
    <>
      <div className="ph20 mt10">
        {addModVsble ? (
          <div className="mt10">
            <div className="flex-row">
              <Typography className="blue-color fs14 txt-semi-bold mt5">
                Name :
              </Typography>
              <div className="w70Per ml20">
                <CustomSelect
                  list={getFormList()}
                  value={formValue}
                  error={formErr}
                  helperText={formErr ? "This field is required" : ""}
                  label=""
                  handleChange={(e, value) => handleSave(value?.formId)}
                  search
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="flex-row-ali-cen ph20">
              <div className="w35Per">
                <Typography className="font-bold blue-color fs12">
                  Name
                </Typography>
              </div>
              <div className="w15Per">
                <Typography className="font-bold blue-color fs12">
                  Status
                </Typography>
              </div>
              <div className="w40Per" />
            </div>
            <div className="blue-hor-split mt5" />
            {reqDet?.forms?.map((pf) => (
              <div className="flex-row-ali-cen ph20 mt10" key={pf?.petFormId}>
                <div className="w35Per">
                  <Custom3dotString
                    str={pf?.name}
                    className="txt-semi-bold blue-color fs12"
                    length={25}
                  />
                </div>
                <div className="w15Per">
                  <div
                    className={`${
                      pf?.status ? "green-back5" : "red-back2"
                    } ph20 pv5 br5 wdth-max-cnt`}
                  >
                    <Typography className="font-medium fs12 white-color">
                      {pf?.status ? "Signed" : "Pending"}
                    </Typography>
                  </div>
                </div>
                <div className="w50Per">
                  <div className="flex-row-ali-cen">
                    {canManageDashboard && !pf?.status ? (
                      <div>
                        <CustomButton
                          text="Sign now"
                          smallBtn
                          onClick={() => handleSign(pf)}
                        />
                      </div>
                    ) : null}
                    {/* <div className="ml10">
                    <CustomButton text="Send for Signature" smallBtn />
                  </div> */}
                    <div className="flex1-end">
                      {canManageDashboard && addEditShow ? (
                        <div className="cursor" onClick={() => delForm(pf)}>
                          <div className="flex-center">
                            <DeleteOutlineIcon sx={delBtn} />
                          </div>
                          <Typography className="red3 fs8 txt-semi-bold text-align-center">
                            Delete
                          </Typography>
                        </div>
                      ) : null}
                      {canManageDashboard ? (
                        <div
                          className={`cursor ${addEditShow ? "ml20" : ""}`}
                          onClick={() => handleView(pf)}
                        >
                          <div className="flex-center">
                            <VisibilityIcon sx={eyeBtn} />
                          </div>
                          <Typography className="blue-color fs8 txt-semi-bold text-align-center">
                            View
                          </Typography>
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {canManageDashboard && addEditShow ? (
              <div
                className="flex-row-ali-cen mt20 cursor"
                onClick={() => setAddModVsble(true)}
              >
                <div className="flex-center plus-icon">
                  <AddIcon sx={addIcon} />
                </div>
                <Typography className="blue-color fs16 ml5 font-bold">
                  Add
                </Typography>
              </div>
            ) : null}
          </>
        )}
      </div>

      <div style={{ display: "none" }}>
        <div ref={pdfRef} className="bg ph20 mb20">
          <div className="flex-row-ali-cen mv20">
            <div className="w20Per">
              <div className="pl20">
                <div>
                  {profileImg ? (
                    <img src={profileImg} className="img-h75" alt="" />
                  ) : (
                    <div className="flex-center h50img">
                      <Typography className="font-bold fs30 white-color capitalize">
                        {profile?.name?.[0]}
                      </Typography>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="w60Per flex-center">
              <div className="font-bold fs30 blue-color">
                {slctedItem?.name}
              </div>
            </div>
            <div className="w20Per flex1-end">
              <div className="pr10">
                <img
                  src={require("../../../../assets/images/png/VetInstantLogo.png")}
                  alt=""
                  className="wh50 blu-back p5"
                />
              </div>
            </div>
          </div>
          <div className="yellow-bar" />
          <div dangerouslySetInnerHTML={{ __html: slctedItem?.content }} />
          <div className="mt100">
            <div className="flex-row-ali-cen">
              {signatureUrl ? (
                <img src={signatureUrl} alt="" className="h60" />
              ) : null}
              <div className="flex1-end">
                {vetSignUrl ? (
                  <img src={vetSignUrl} alt="" className="h60" />
                ) : null}
              </div>
            </div>
            <div className="flex-row-ali-cen">
              <Typography className="fs16 font-bold black">
                Signature of pet parent
              </Typography>
              <div className="flex1-end">
                <Typography className="fs16 font-bold black">
                  Signature of licensed veterinarian
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CustomModal
        open={delModVsble}
        onClose={onCloseDelMod}
        header="Delete Form"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the form?
        </Typography>

        <div className="clinic-mod-btn-pos mb10 mt15">
          <div className="mr10">
            <CustomButton text="Yes" redBtn onClick={onCofirmDelete} smallBtn />
          </div>
          <div className="ml10">
            <CustomButton text="No" onClick={onCloseDelMod} smallBtn />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={signModVsble || contPrevModVsble}
        onClose={onCloseSignMod}
        header={contPrevModVsble ? "Preview " : "Signature"}
        modal
        modalWidth={70}
      >
        {contPrevModVsble ? (
          <div className="scroll-70vh">
            <div className="bg ph20 mb20">
              <div className="flex-row-ali-cen mv20">
                <div className="w20Per">
                  <div className="pl20">
                    <div>
                      {profileImg ? (
                        <img src={profileImg} className="img-h75" alt="" />
                      ) : (
                        <div className="flex-center h50img">
                          <Typography className="font-bold fs30 white-color capitalize">
                            {profile?.name?.[0]}
                          </Typography>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="w60Per flex-center">
                  <div className="font-bold fs30 blue-color">
                    {slctedItem?.name}
                  </div>
                </div>
                <div className="w20Per flex1-end">
                  <div className="pr10">
                    <img
                      src={require("../../../../assets/images/png/VetInstantLogo.png")}
                      alt=""
                      className="wh50 blu-back p5"
                    />
                  </div>
                </div>
              </div>
              <div className="yellow-bar" />
              <div dangerouslySetInnerHTML={{ __html: slctedItem?.content }} />
              <div className="mt100">
                <div className="flex-row-ali-cen">
                  {signatureUrl ? (
                    <img src={signatureUrl} alt="" className="h60" />
                  ) : null}
                  <div className="flex1-end">
                    {vetSignUrl ? (
                      <img src={vetSignUrl} alt="" className="h60" />
                    ) : null}
                  </div>
                </div>
                <div className="flex-row-ali-cen">
                  <Typography className="fs16 font-bold black">
                    Signature of pet parent
                  </Typography>
                  <div className="flex1-end">
                    <Typography className="fs16 font-bold black">
                      Signature of licensed veterinarian
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <SignatureCanvas
            ref={sigCanvas}
            canvasProps={{
              width: (window.innerWidth / 100) * 65,
              height: 300,
              className: "sigCanvas",
            }}
          />
        )}
        <div className="flex-center">
          <div>
            <CustomButton
              text={contPrevModVsble ? "Continue to Sign" : "Save"}
              smallBtn
              onClick={() => {
                if (contPrevModVsble) {
                  setContPrevModVsble(false);
                  setSignModVsble(true);
                } else {
                  onSaveSign();
                }
              }}
            />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={contentEditModVsble}
        onClose={onCloseContentEdit}
        header={slctedItem?.name || "Form preview"}
        modal
        modalWidth={90}
      >
        <div className="scroll-70vh ph10">
          <ReactQuill
            onChange={setEditContent}
            value={editContent}
            style={{ minHeight: 320 }}
          />
          {/* <div className="mt100">
            <div className="flex-row-ali-cen">
              <Typography className="fs16 font-bold black">
                Signature of pet parent
              </Typography>
              <div className="flex1-end">
                <Typography className="fs16 font-bold black">
                  Signature of licensed veterinarian
                </Typography>
              </div>
            </div>
          </div> */}
        </div>
        <div className="flex-center mv20">
          <div className="mr10">
            <CustomButton
              text="Cancel"
              redBtn
              onClick={onCloseContentEdit}
              smallBtn
            />
          </div>
          <div className="ml10">
            <CustomButton text="Save" smallBtn onClick={onSaveContent} />
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={prevModVsble}
        onClose={onClosePreview}
        header={slctedItem?.name || "Preview"}
        modal
        modalWidth={90}
      >
        <div className="scroll-70vh">
          <div className="flex-center w100Per">
            {pdfPreviewLoading ? (
              <Typography className="txt-regular fs14 gray4 pv20">
                Loading PDF...
              </Typography>
            ) : pdfPreviewUrl ? (
              <object
                key={`${slctedItem?.petFormId}-${pdfPreviewUrl}`}
                data={`${pdfPreviewUrl}#toolbar=1&navpanes=0`}
                type="application/pdf"
                className="pdf-prev"
                style={{ height: "70vh", width: "100%" }}
              >
                <iframe
                  title={slctedItem?.name || "Form preview"}
                  src={`${pdfPreviewUrl}#toolbar=1&navpanes=0`}
                  className="pdf-prev"
                  style={{ height: "70vh", width: "100%", border: 0 }}
                />
              </object>
            ) : (
              <Typography className="txt-regular fs14 red3 pv20">
                {pdfPreviewError || "Unable to load PDF preview."}
              </Typography>
            )}
          </div>
          {pdfPreviewError ? (
            <Typography className="txt-regular fs12 gray4 text-align-center mt10">
              {pdfPreviewError}
            </Typography>
          ) : null}
          <div className="flex-center">
            <div className="mt20 flex-row-ali-cen">
              <CustomButton
                text="Open in new tab"
                onClick={openPdfInNewTab}
                smallBtn
              />
              <div className="ml20">
                <CustomButton
                  text="Download"
                  onClick={() =>
                    downloadFile(slctedItem?.file, `${slctedItem?.name}.pdf`)
                  }
                  smallBtn
                />
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default PetForms;
